import { Component, Input, OnInit } from '@angular/core';
import { HostListener, Inject } from '@angular/core';
import {
  trigger,
  state,
  transition,
  style,
  animate,
  keyframes
} from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import { HEADER_WHITE_LOGO, HEADER_BLUE_LOGO } from '../assets/assets_constant';
import { Router, NavigationStart, RouterEvent, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { LocationApiService } from './helper/service/location-api.service';
import { LoaderService } from './shared/service/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('ease-in-out', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [animate(200)]),
      transition(':leave', [animate(200)])
    ]),
    trigger('slideInAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(-50px)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateY(-50px)', opacity: 0 }))
      ])
    ])
  ]
})
export class AppComponent implements OnInit {
  headerLogoPath = HEADER_WHITE_LOGO;
  isHomePage = true;
  isShow = false;
  topPosToStartShowing = 100;
  isLoading = false;
  @Input() toggleButton = false;
  
  // Demo dialog properties
  showDemoDialog = false;
  
  // Benefits data
  benefits = [
    {
      icon: 'zap',
      title: 'Rapid Implementation',
      description: 'Quick setup and deployment with minimal disruption to your existing operations.'
    },
    {
      icon: 'shield-check',
      title: 'Enterprise Security',
      description: 'Bank-grade security with advanced encryption and compliance standards.'
    },
    {
      icon: 'bar-chart-3',
      title: 'Real-time Analytics',
      description: 'Comprehensive reporting and analytics for data-driven decision making.'
    },
    {
      icon: 'users',
      title: '24/7 Support',
      description: 'Round-the-clock technical support from our expert team.'
    }
  ];

  // Trust statistics
  trustStats = [
    { number: '500+', label: 'Happy Clients' },
    { number: '99.9%', label: 'Uptime Guarantee' },
    { number: '24/7', label: 'Expert Support' },
    { number: '15+', label: 'Years Experience' }
  ];
  constructor(@Inject(DOCUMENT) document, public router: Router, private locationApiService: LocationApiService, private loaderService: LoaderService) {
    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationStart) {
        if (!(event.url === '/')) {
          this.isHomePage = false;
          this.headerWhite();
        } else {
          this.isHomePage = true;
          this.headerTrasperent();
        }
      }
    });
    this.router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event)
    })
  }

  ngOnInit(): void {
    // this.checkIpfromIndia();
    this.loaderService.getLoader().subscribe((data)=> {
      this.isLoading = data;
    });
    
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    const navbar = document.querySelector('.modern-navbar');
    if (this.isHomePage) {
      if (window.pageYOffset > 50) {
        this.headerWhite();
        if (navbar) {
          navbar.classList.add('scrolled');
        }
      } else {
        this.headerTrasperent();
        if (navbar) {
          navbar.classList.remove('scrolled');
        }
      }
      this.toggleButton = window.pageXOffset > 767 ? false : true;
    } else {
      // Internal pages: Always show blue background
      if (navbar) {
        navbar.classList.add('scrolled');
      }
      this.headerWhite();
    }
    // get scroll position
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    // Check weather window is scrolled or not.
    if (scrollPosition >= this.topPosToStartShowing) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }
  onToggleChange(event) {
    if (event) {
      this.headerWhite();
      this.headerLogoPath = HEADER_BLUE_LOGO;
    } else {
      if (!(window.pageYOffset > 50)) {
        this.headerTrasperent();
        this.headerLogoPath = HEADER_BLUE_LOGO;
      }
    }
  }
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  headerWhite() {
    const element = document.getElementById('navbar');
    (element) ? element.classList.remove('unsticky') : ''; // if element 
    (element) ? element.classList.add('sticky') : '';
    this.headerLogoPath = HEADER_BLUE_LOGO;
  }
  headerTrasperent() {
    const element = document.getElementById('navbar');
    (element) ? element.classList.remove('sticky') : ''; // if element 
    (element) ? element.classList.add('unsticky') : '';
    this.headerLogoPath = HEADER_WHITE_LOGO;
  }

  checkIpfromIndia() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        if (position.coords.latitude && position.coords.longitude) {
          this.locationApiService.getIPAddress(position.coords.latitude, position.coords.longitude).subscribe((res: any) => {
            // this.ipAddress = res.ip;
            console.log(res);
          });
        }
      });
    }
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loaderService.setLoader('true');
      this.isLoading = true;
    }
    if (event instanceof NavigationEnd) {
      setTimeout(() => {
        this.loaderService.setLoader('false');
        this.isLoading = false;
        
        // Ensure blue header on internal pages after navigation
        if (!this.isHomePage) {
          const navbar = document.querySelector('.modern-navbar');
          if (navbar) {
            navbar.classList.add('scrolled');
          }
          this.headerWhite();
        }
      }, 1400);
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loaderService.setLoader('false');
      this.isLoading = false;
    }
    if (event instanceof NavigationError) {
      this.loaderService.setLoader('false');
      this.isLoading = false;
    }
  }

  // Demo dialog methods
  openDemoDialog(): void {
    this.showDemoDialog = true;
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }

  closeDemoDialog(event?: MouseEvent): void {
    if (event && event.target !== event.currentTarget) {
      return; // Don't close if clicking inside the dialog
    }
    this.showDemoDialog = false;
    document.body.style.overflow = 'auto'; // Restore scrolling
  }

  onFormSubmitted(success: boolean): void {
    if (success) {
      this.closeDemoDialog();
    }
  }

}
